export const DEFAULT_TILE_SOURCE_OPTIONS = ['esri', 'planetlabs', 'googlemaps', 'kropyva', 'ortophoto'];
